import React, { useEffect } from 'react'
import PropTypes from 'prop-types'
import Input from 'shared/components/form/Input/Input.component'
import Spinner from 'shared/components/common/Spinner/Spinner.component'

import { createDivAtom } from 'shared/atoms/factory'

import styles from './ReportingConfig.module.scss'

const Wrapper = createDivAtom(),
      ContentWrapper = createDivAtom(),
      InputRow = createDivAtom(),
      Title = createDivAtom()

const ReportingConfig = props => {
  const {
    isFetchingConfig,
    isSavingConfig,
    agentId,
    reportingConfig,
    updateReportingConfig,
    fetchReportingConfig
  } = props

  useEffect(() => {
    if(agentId && agentId !== 'default') {
      fetchReportingConfig()
    }
  }, [ agentId ])

  return (
    <Wrapper className={styles.wrapper}>
      <Spinner visible={isFetchingConfig || isSavingConfig} />

      <ContentWrapper className={styles.contentWrapper}>
        <Title className={styles.title}>
          Reporting attributes
        </Title>

        <InputRow className={styles.inputRow}>
          <div className={styles.inputMarginRight}>
            <Input
              placeholder={'For example "EMEA"'}
              className={styles.input}
              title={'Region'}
              value={reportingConfig.region}
              onChange={updateReportingConfig('region')}
              disabled={isFetchingConfig || isSavingConfig}
            />
          </div>
          <Input
            placeholder={'For example "US"'}
            className={styles.input}
            title={'Country'}
            value={reportingConfig.country}
            onChange={updateReportingConfig('country')}
            disabled={isFetchingConfig || isSavingConfig}
          />
        </InputRow>

        <InputRow className={styles.inputRow}>
          <div className={styles.inputMarginRight}>
            <Input
              placeholder={'For example "Awesome corp"'}
              className={styles.input}
              title={'Client identifier'}
              value={reportingConfig.clientIdentifier}
              onChange={updateReportingConfig('clientIdentifier')}
              disabled={isFetchingConfig || isSavingConfig}
            />
          </div>
          <Input
            placeholder={'For example "internal"'}
            className={styles.input}
            title={'Use case identifier'}
            value={reportingConfig.useCaseIdentifier}
            onChange={updateReportingConfig('useCaseIdentifier')}
            disabled={isFetchingConfig || isSavingConfig}
          />
        </InputRow>

      </ContentWrapper>
    </Wrapper>
  )
}

ReportingConfig.propTypes = {
  isFetchingConfig: PropTypes.bool,
  isSavingConfig: PropTypes.bool,
  agentId: PropTypes.string,
  reportingConfig: PropTypes.object,
  updateReportingConfig: PropTypes.func,
  fetchReportingConfig: PropTypes.func
}

export default ReportingConfig
